<section
  class="rs-content-wrapper rs-header-has-level2"
  id="tvLevelTwo"
  *ngIf="!hasError || selectedProduct || isPending"
>
  <mprd-skeleton-tv-level-two *ngIf="!selectedProduct"></mprd-skeleton-tv-level-two>
  <main *ngIf="selectedProduct" id="maincontent" role="main">
    <section class="rs-pos-rel rs-mh-s25 rs-mh-m35">
      <mprd-back-link></mprd-back-link>
      <div class="rs-bg-black rs-bgtl-7 rs-pos-tl rs-maxw rs-mh-s25 rs-mh-m35"></div>
      <div>
        <div class="row">
          <div class="columns small-12">
            <div class="rs-pos-rel">
              <div class="rs-fe3"></div>
              <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit" data-cy="tvTitle">
                {{ 'tv.title' | translate }}
              </h1>
              <p class="rs-txt-s5 rs-txt-c2" x-ms-format-detection="none">
                <mprd-access-number-formatter
                  [accessNumber]="selectedProduct?.accessNumber"
                  [plc]="selectedProduct?.plc"
                ></mprd-access-number-formatter>
              </p>
              <div class="panel rs-panel-big clearfix">
                <h2 class="rs-tit3">{{ 'common.options' | translate }}</h2>

                <div class="rs-flex-row" data-cy="tvOptionBox">
                  <div *ngIf="tvBonusEligible" class="rs-flex-columns small-12 medium-6">
                    <mprd-tv-bonus [product]="selectedProduct"></mprd-tv-bonus>
                  </div>
                  <div class="rs-flex-columns small-12 medium-6">
                    <mprd-netflix-banner [product]="selectedProduct"></mprd-netflix-banner>
                  </div>
                </div>

                <div class="rs-me"></div>

                <mprd-tv-available-options-container></mprd-tv-available-options-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</section>
